import {createReducer} from "redux-act";
import {fetchAchievementsCountSuccess, fetchUserLevelSuccess} from "modules/actions";
import {IMAGES_URL} from "modules/constants";

export interface IGamezoneBannerState {
	banner: IGamezoneBanner
	level: IGamezoneLevel
}

export interface IGamezoneLevel {
	userId: string
	gamezoneLevel: number
	gamezoneAvatar: string
}

export interface IGamezoneBanner {
	totalCount: number;
	earnedCount: number;
	notEarnedCount: number;
}

const initial: IGamezoneBannerState = {
	banner: {
		totalCount: 0,
		earnedCount: 0,
		notEarnedCount: 0,
	},
	level: {
		gamezoneLevel: 0,
		gamezoneAvatar: `${IMAGES_URL}media/image/gamezone/avatars/0.svg`,
		userId: ''
	}
};

export const gamezoneBaner = createReducer<IGamezoneBannerState>({}, initial).on(
	fetchAchievementsCountSuccess,
	(state: IGamezoneBannerState, payload) => ({
		...state,
		banner: payload,
	})
).on(
	fetchUserLevelSuccess,
	(state: IGamezoneBannerState, payload: IGamezoneLevel) => ({
		...state,
		level: payload,
	})
);
